import { Reveal } from "./Reveal";

const QUOTES = [
  {
    quote: "For the first time, I understood exactly what I was paying for — and what I wasn't.",
    attribution: "Public servant, Barton",
    testid: "testimonial-1",
  },
  {
    quote: "Kevin talked us out of a product we didn't need. That's when I knew we'd found the right adviser.",
    attribution: "Retiree, Deakin",
    testid: "testimonial-2",
  },
  {
    quote: "Fixed fees meant our advice didn't get more expensive just because our savings grew.",
    attribution: "Business owner, Kingston",
    testid: "testimonial-3",
  },
];

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="bg-[#EFEBE2] py-16 md:py-36">
    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <div data-testid="testimonials-divider" aria-hidden="true" className="flex items-center justify-center gap-6 mb-16 md:mb-20">
        <span className="h-px w-16 md:w-28 bg-[#0A2333]/15" />
        <img src="/assets/nua-mark-transparent.png" alt="" className="h-9 w-auto opacity-90" />
        <span className="h-px w-16 md:w-28 bg-[#0A2333]/15" />
      </div>
      <Reveal>
        <p className="flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-[#0A2333]">
          <span className="h-px w-10 bg-[#0A2333]" aria-hidden="true" />
          In their words
        </p>
        <h2 data-testid="testimonials-heading" className="mt-6 font-serif text-3xl md:text-4xl tracking-tight text-[#111413] max-w-xl">
          What clients notice first is what's missing.
        </h2>
      </Reveal>

      <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10">
        {QUOTES.map((q, i) => (
          <Reveal key={q.testid} delay={i * 0.1}>
            <figure data-testid={q.testid} className="border-t border-black/15 pt-8 h-full flex flex-col">
              <span aria-hidden="true" className="font-serif text-6xl leading-none text-[#A78558]">“</span>
              <blockquote className="mt-2 font-serif text-xl md:text-2xl leading-snug text-[#111413] flex-1">
                {q.quote}
              </blockquote>
              <figcaption className="mt-8 text-[10px] uppercase tracking-[0.25em] text-[#4A524D]">
                {q.attribution}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-14 text-xs text-[#4A524D]" data-testid="testimonials-note">
          Client names withheld for privacy. Testimonials shared with permission.
        </p>
      </Reveal>
    </div>
  </section>
);
